<script setup>
import { useCommonImports } from '~/common/composables/common-imports.composable.js';
import { useTerraStore } from '~/terra/store/terra.store.js';
import { useFeatureActions } from '~/terra/utils/feature-actions.composable.js';

const { moveSelectedFeatures, deleteSelectedFeatures, handleClearSerialNumbers } = useFeatureActions();
const { $t } = useCommonImports();
const terra_store = useTerraStore();

const hawk_menu_items = computed(() => {
  return [
    {
      uid: 'move',
      label: $t('Move'),
      disabled: !terra_store.check_permission('modify_features'),
      tooltip: !terra_store.check_permission('modify_features') ? $t('You don\'t have permissions to perform this action.') : '',
      on_click: () => {
        moveSelectedFeatures();
      },
    },
    {
      uid: 'clear-serial-numbers',
      label: $t('Clear serial numbers'),
      disabled: !terra_store.check_permission('modify_feature_properties'),
      tooltip: !terra_store.check_permission('modify_feature_properties') ? $t('You don\'t have permissions to perform this action.') : '',
      on_click: () => {
        handleClearSerialNumbers();
      },
    },
    {
      uid: 'delete',
      label: $t('Delete'),
      disabled: !terra_store.check_permission('modify_features'),
      tooltip: !terra_store.check_permission('modify_features') ? $t('You don\'t have permissions to perform this action.') : '',
      on_click: () => {
        deleteSelectedFeatures();
      },
    },
  ];
});
</script>

<template>
  <div>
    <HawkMenu
      :items="hawk_menu_items"
      position="fixed"
      :has_bordered_trigger="false"
      additional_trigger_classes="!ring-0 p-0 -mt-1"
      additional_dropdown_classes="max-h-60 scrollbar"
    >
      <template #trigger="{ open }">
        <hawk-button type="outlined">
          {{ $t('Actions') }}
          <IconHawkChevronDown
            class="text-white transition-transform"
            :class="{ 'rotate-180': open }"
          />
        </hawk-button>
      </template>
    </HawkMenu>
  </div>
</template>
